import React from "react";
import { createPortal } from "react-dom";
import { useMask } from "../Contexts/mask.context";

const GlobalMask = () => {
  const { showMask } = useMask(); // from your context

  if (!showMask) return null;

  // Renders above everything; adjust zIndex if you have higher UI layers
  return createPortal(
    <div
      aria-hidden="true"
      role="presentation"
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(93, 90, 90, 0.75)",
        zIndex: 200,          // bump higher if needed
        pointerEvents: "auto", // block clicks behind
        backdropFilter: "blur(1px)"
      }}
    />,
    document.body
  );
};

export default GlobalMask;
